import {EventBus} from "../events/EventBus";
import {Section} from "../services/Section";
import {
    ChatButtonClickedEvent,
    ObfuscatedElementClickedEvent,
    ObfuscatedElementClickedEventPayload
} from "../events/Events";
import PageData from "../PageData";
import {getChatSectionIdsMap} from "../ChatSections";

const ChatSectionMap = new Map([
    ['button-chat-whatsapp-desktop', Section.SECTION_ADPAGE_RIGHT_WHATSAPP],
    ['button-chat-line-desktop', Section.SECTION_ADPAGE_RIGHT_LINE],
    ['button-chat-messenger-desktop', Section.SECTION_ADPAGE_RIGHT_MESSENGER],
]);

export default class ChatButtons {
    private readonly pageData: PageData;

    private constructor(pageData: PageData) {
        this.pageData = pageData;
        this.addEventListeners();
    }

    static init(pageData: PageData) {
        new ChatButtons(pageData);
    }

    addEventListeners() {
        const eventBus: EventBus = EventBus.getInstance();
        document.querySelectorAll('.js-chat-button').forEach((chatButton) => {
            chatButton.addEventListener('click', (event) => {
                event.stopPropagation();
                event.preventDefault();
                const definedSectionOrStringEmpty: Section | string | null = chatButton.getAttribute('data-section');
                const section = definedSectionOrStringEmpty || ChatSectionMap.get(chatButton.id);
                if (section != undefined) {
                    eventBus.emit(new ChatButtonClickedEvent({
                        propertyAdId: this.pageData.id,
                        pageViewId: this.pageData.pageViewId,
                        step: 2,
                        htmlButtonClicked: chatButton as HTMLElement,
                        section: section as Section,
                        pageViewType: this.pageData.pageViewType,
                    }));
                }
            });
        });

        const chatSectionIdsMap = getChatSectionIdsMap();
        eventBus.subscribe(ObfuscatedElementClickedEvent.TYPE, (event) => {
            const payload: ObfuscatedElementClickedEventPayload = (event as ObfuscatedElementClickedEvent).payload;
            if (chatSectionIdsMap.has(payload.section)) {
                eventBus.emit(new ChatButtonClickedEvent({
                    propertyAdId: this.pageData.id,
                    pageViewId: this.pageData.pageViewId,
                    step: 2,
                    htmlButtonClicked: payload.htmlButtonClicked,
                    section: payload.section,
                    pageViewType: this.pageData.pageViewType,
                }));
            }
        });
    }
};